"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPageTitle;

var _lang = _interopRequireDefault(require("@/lang"));

var _store = _interopRequireDefault(require("@/store"));

function getPageTitle(key) {
  var title = _store.default.getters.title;

  var hasKey = _lang.default.te("route.".concat(key));

  if (hasKey) {
    var pageName = _lang.default.t("route.".concat(key));

    return "".concat(pageName);
  }

  return "".concat(title);
} // :width="logos.logoWidth"
// :height="logos.logoHeight"